module.exports = __webpack_public_path__ + "img/D2.bc130055.png";